import { CustomModalProps, Modal } from '@dynamika-shared/ui/Modal/Modal';
import { ModalProps } from 'antd';
import { FC, useMemo } from 'react';
import { twMerge } from '@utils/twMerge';

type ConfirmationProps = {
  modalType: MembersModalType;
  onCancel: () => void;
  onOk: () => void;
};

export type MembersModalType =
  | 'ACTIVATE_MEMBER'
  | 'SUSPEND_MEMBER'
  | 'DELETE_MEMBER';

export const ConfirmationMembers: FC<ConfirmationProps> = ({
  modalType,
  onCancel,
  onOk,
}) => {
  const confirmationMode: Record<
      MembersModalType,
    Partial<ModalProps & CustomModalProps>
  > = useMemo(
    () => ({
      ACTIVATE_MEMBER: {
        children: (
          <>
            Are you sure you want to <br />
            activate this Member?
          </>
        ),
        title: 'Activate Member',
        okText: 'Activate',
        onOk,
        onCancel,
      },
      SUSPEND_MEMBER: {
        children: (
          <>
            Are you sure you want to <br />
            suspend this Member?
          </>
        ),
        title: 'Suspend Member',
        onCancel,
        cancelText: 'Cancel',
        onOk,
        okText: 'Suspend',
      },
      DELETE_MEMBER: {
        children: (
          <>
            Are you sure you want to <br />
              delete this Member?
          </>
        ),
        title: 'Delete Member',
        onCancel,
        cancelText: 'Cancel',
        onOk,
        okText: 'Delete',
      },
    }),
    [onCancel, onOk]
  );
  return (
    <Modal
      {...confirmationMode[modalType]}
      open={!!modalType}
      width={440}
      centered
      maskClosable={false}
      mask={false}
      okClassName={twMerge(modalType !== 'ACTIVATE_MEMBER' && 'ant-btn-dangerous')}
      titleClassName='text-left'
      classNames={{
        header: 'text-left',
        content: 'text-center !rounded-[2.4rem] !p-[4rem]',
        footer: 'flex justify-center',
      }}
      data-testid='deleteMemberModal'
    />
  );
};
